export default (_locale: string, key: string): string =>
  // console.warn(`Missing translation for key "${key}" and locale ${locale}`)
  key
